import { supabase } from '../lib/supabase';

export interface PartnerTool {
  id: string;
  name: string;
  logo_url: string;
  href: string;
  category: string | null;
  order_index: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const loadPartnerTools = async (): Promise<PartnerTool[]> => {
  try {
    const { data, error } = await supabase
      .from('v_partner_tools')
      .select('*')
      .eq('is_active', true)
      .order('order_index', { ascending: true });
    if (error) throw error;
    return (data as unknown as PartnerTool[]) || [];
  } catch (error) {
    console.error('Erro ao carregar partner_tools:', error);
    return [];
  }
};

export const createPartnerTool = async (
  payload: Omit<PartnerTool, 'id' | 'created_at' | 'updated_at'>
): Promise<PartnerTool | null> => {
  try {
    const { data, error } = await supabase
      .from('partner_tools')
      .insert(payload)
      .select()
      .single();
    if (error) throw error;
    return data as PartnerTool;
  } catch (error) {
    console.error('Erro ao criar partner_tool:', error);
    return null;
  }
};

export const updatePartnerTool = async (
  id: string,
  updates: Partial<PartnerTool>
): Promise<PartnerTool | null> => {
  try {
    const { data, error } = await supabase
      .from('partner_tools')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data as PartnerTool;
  } catch (error) {
    console.error('Erro ao atualizar partner_tool:', error);
    return null;
  }
};


